import axios from "axios";
import { corsBypass, REACT_APP_BASE_URL_METIS } from "../constants/enviroments";
import { interceptorHelper } from "./interceptor";
import { handleAxiosError } from "./Axios";

let UserAxios = axios.create({
  baseURL: `${
    process.env.NODE_ENV === "development" ? corsBypass : ""
  }${REACT_APP_BASE_URL_METIS}`,
});

UserAxios.interceptors.request.use(
  interceptorHelper.config,
  interceptorHelper.error
);

UserAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    return handleAxiosError(error);
  }
);

export async function GetUser(token) {
  return UserAxios.get(`/users/me`);
}

export async function GetUserProfile(id) {
  return UserAxios.get(`/full-profile/${id}`);
}

export async function GetUsernameProfile(username) {
  return UserAxios.get(`/profile/${username}`);
}

export async function updateUserInterests(data) {
  return UserAxios.post(`/users/mentorship/interests`, data);
}
export async function deleteUserInterests(data) {
  return UserAxios.delete(`/users/mentorship/interests`, {
    data,
  });
}

export async function createNote(data) {
  return UserAxios.post(`/notes`, data);
}

export async function deleteNote(id) {
  return UserAxios.delete(`/notes/${id}`);
}

export async function getNotes() {
  return UserAxios.get(`/notes`);
}

export async function updateNote(data, id) {
  return UserAxios.patch(`/notes/${id}`, data);
}

export async function confirmOrder(data) {
  return UserAxios.post(`/appointments/payment/process`, data);
}
